import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import Modal from './Modal.jsx';

const ModalConfirm = (props) => {
  const {
    show,
    icon,
    children,
    onReject = () => {},
    onConfirm = () => {},
    theme = 'warning',
  } = props;
  const { t } = useTranslation();

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onReject}
      centered
      className="p-4 text-center"
    >
      {icon !== null && (
        <div className={`display-4 my-3 text-${theme}`}>
          <FA icon={icon || faExclamationTriangle} />
        </div>
      )}
      {children}
      <div className="form-row mt-4">
        <div className="col">
          <button
            className={`btn btn-block btn-outline-${theme}`}
            onClick={onReject}
          >
            {t('Cancel')}
          </button>
        </div>
        <div className="col">
          <button
            className={`btn btn-block btn-${theme}`}
            onClick={onConfirm}
          >
            {t('Confirm')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
